export default "__VITE_ASSET__1cb96c96__"